/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ICalculationConfigurationScope extends angular.IScope {
        model: models.CalculationConfigurationModel
    }

    export class CalculationConfigurationController implements IController {
        constructor(
            private scope: ICalculationConfigurationScope,
            $routeParams: angular.route.IRouteParamsService,
            processConfigurationService: services.ProcessConfigurationService,
            systemLevelService: services.SystemLevelService,
            calculationService: services.CalculationService,
            objectSchemaService: services.ObjectSchemaService,
            deleteService: services.DeleteService,
            growlService: angular.growl.IGrowlService)
        {
            var processConfigurationId = $routeParams["id"];
            var calculationId = $routeParams["subId"];

            this.scope.model = new models.CalculationConfigurationModel(
                processConfigurationId,
                calculationId,
                processConfigurationService,
                systemLevelService,
                calculationService,
                objectSchemaService,
                deleteService,
                growlService);
        }
    }
}

warsApp.registerController('CalculationConfigurationController', [
    '$scope', '$routeParams', 'processConfigurationService', 'systemLevelService', 'calculationService', 'objectSchemaService', 'deleteService', 'growl'
]);